import http from 'hub-http/clients/apiClient';

// https://tools.hubteam.com/api-catalog/services/ConnectedAccountsService/v1/spec/internal#operations-Account-get-%2Fconnectedaccounts%2Fv1%2Faccounts%2Fconnected-inboxes

export const fetchConnectedInboxes = () => http.get('connectedaccounts/v1/accounts/connected-inboxes');